<!--  -->
<template>
  <div class="footer">
    <div class="footer-row">
      <h1 class="footer-logo"><img src="../assets/images/livu-logo-1.png" alt=""></h1>
      <div class="footer-icon">
        <a href="https://h5-livume.onelink.me/llU8/wuwb2q4y" target="_blank" class=""><img class="img-app" src="../assets/images/google.png"/></a>
        <a href="https://apps.apple.com/us/app/livu-live-video-chat/id1273950116" target="_blank" class=""><img class="img-app" src="../assets/images/app-store.png"/></a>
      </div>
    </div>
    <div class="footer-row only-text">
      <p>© 2023 Clash Arts HK Limited. All Rights Reserved.<br>Suite 3705A, Hopewell Centre, 183 Queen's Road East, Wanchai, Hong Kong</p>
      <p class="footer-links"><a href="https://privacy.livuchat.com/LivU_privacy.html" target="_blank">Privacy Policy</a><a href="https://privacy.livuchat.com/LivU_us_privacy.html" target="_blank">US State Privacy Rights</a><a href="https://privacy.livuchat.com/LivU_termsofservice.html" target="_blank">Terms and Conditions</a><a href="https://privacy.livuchat.com/livu_dsa_help_center.html" target="_blank">DSA help center</a></p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}

</script>
<style lang='scss' scoped>
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
  .footer {
    // background-color: $primary;
    // background: linear-gradient(90deg,#A8558F 0%,#5E33BE 100%);
    background: url('../assets/images/background.png') no-repeat;
    background-size:  100% 100%;
    width: 100%;
    height: 140px;
    padding: 30px 0;
    position: absolute;
    .footer-logo {
      width: 85px;
      img {
        max-width: 100%;
      }
    }
    .footer-row {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .only-text p {
      color: #fff;
      font-size: 16px;
      padding-top: 5px;
      a {
        color: #fff;
      }
    }
    .footer-links a {
      margin-right: 20px;
    }
    .footer-icon {
      display: flex;
      .img-app{
        width: 180px;
        height:60px;
        margin-right: 20px;
      }
      .footer-i {
        width: 180px;
        height: 42px;
        padding-left: 30px;
        background-color: #fff;
        border-radius: 21px;
        margin-left: 20px;
        color: $primary;
        box-shadow:4px 4px 21px 0px rgba(0,0,0,0.08);
        text-align: center;
        line-height: 42px;
        font-size: 16px;
        position: relative;
        text-decoration: none;
        &.google::before {
          content: '';
          position: absolute;
          top: 6px;
          left: 25px;
          background: url('../assets/images/google-icon.png') no-repeat;
          width: 32px;
          height: 32px;
        }
        &.android::before {
          content: '';
          position: absolute;
          top: 11px;
          left: 30px;
          background: url('../assets/images/android-icon.png') no-repeat;
          width: 20px;
          height: 22px;
        }
        &.ios::before {
          content: '';
          position: absolute;
          top: 5px;
          left: 25px;
          background: url('../assets/images/ios-icon.png') no-repeat;
          width: 32px;
          height: 32px;
        }
      }
    }
  }
}
@media (max-width: 750px) {
  .footer {
    // background-color: $primary;
    background: url('../assets/images/background.png') no-repeat;
    background-size:  100% 100%;
    padding: 10px 20px;
    width: 100%;
    .footer-logo {
      width: 55px;
      img {
        max-width: 100%;
      }
    }
    .footer-row {
      text-align: left;
    }
    .only-text {
      margin-top: 10px;
    }
    .only-text p {
      color: #fff;
      font-size: 12px;
      padding-top: 10px;
      a {
        color: #fff;
      }
    }
    .footer-links {
      display: flex;
      flex-direction: column;
      a {
        margin-bottom: 8px;
      }
    }
    .footer-icon {
      display: flex;
      margin-top: 12px;
      .img-app{
        width: 100px;
        height: 35px;
        margin-right: 10px;
      }
      .footer-i {
        width: 143px;
        height: 33px;
        padding-left: 20px;
        background-color: #fff;
        border-radius: 21px;
        margin-right: 20px;
        color: $primary;
        box-shadow:4px 4px 21px 0px rgba(0,0,0,0.08);
        text-align: center;
        line-height: 33px;
        font-size: 12px;
        font-weight: bold;
        position: relative;
        text-decoration: none;
        &.google::before {
          content: '';
          position: absolute;
          top: 6px;
          left: 25px;
          background: url('../assets/images/google-icon.png') no-repeat;
           background-size: 100%;
          width: 22px;
          height: 22px;
        }
        &.android::before {
          content: '';
          position: absolute;
          top: 6px;
          left: 25px;
          background: url('../assets/images/android-icon.png') no-repeat;
           background-size: 100%;
          width: 22px;
          height: 22px;
        }
        &.ios::before {
          content: '';
          position: absolute;
          top: 5px;
          left: 25px;
          background: url('../assets/images/ios-icon.png') no-repeat;
          background-size: 100%;
          width: 22px;
          height: 22px;
        }
      }
    }
  }
}
</style>
